import i18n from "@/plugins/i18n";
export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
         {
          text: "Question Name",
          value: "questionName",
        },
        {
          text: "Question Key",
          value: "questionKey",
        },
        {
          text: "Top Stars",
          value: "mathRecord.topStar",
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: "Info",
        label: i18n.t("string.info"),
      },
    ],
    table: {
      headers: [
        {
          text: "Mochi Id",
          value: "mochiId",
        },
        {
          text: "Question Name",
          value: "questionName",
        },
        {
          text: "Question Key",
          value: "questionKey",
        },
        {
          text: "Top Stars",
          value: "mathRecord.topStar",
        },
        {
          text: i18n.t("model.prop.lastUpdated"),
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  add: {
    fields: [
      {
        type: "string",
        key: "questionKey",
        name: "Question Key",
      },
    ],
    rules: {
      name: [(v) => !!v || i18n.t("rules.name")],
    },
  },
  edit: false,
  delete: true,
};
